import React from "react";
import { withFormik } from 'formik';
import {displayErrors, withTouchedError, withTouchedErrorClass} from "../../form-helpers";
import {FormattedMessage, injectIntl} from "react-intl";
import {Link} from "react-router-dom";

class SignInForm extends React.Component {
    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, isSubmitting } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                { displayErrors(errors, 'base') }
                <div className='form-group'>
                    <FormattedMessage id='app.auth.sign_in.attribute.email'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <input value={values.email} id='email' type='email' model='email' className='form-control' onChange={handleChange} onBlur={handleBlur}/>
                    { displayErrors(errors, 'email') }
                </div>
                <div className='form-group'>
                    <FormattedMessage id='app.auth.sign_in.attribute.password'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <input value={values.password} id='password' type='password' model='password' className='form-control' onChange={handleChange} onBlur={handleBlur}/>
                    { displayErrors(errors, 'email') }
                </div>
                <hr/>
                <button type='submit' className='btn btn-primary' disabled={isSubmitting}>{intl.formatMessage({id: 'app.auth.sign_in.action.sign_in'})}</button>
                <hr/>
                <Link to='forgotten-password'><FormattedMessage id='app.auth.forgotten_password.title'/></Link>
            </form>
        )
    }
}

export default injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => props.initialValues,
    handleSubmit: (values, form) => { form.props.handleSubmit(values, form); },
    displayName: 'SignInForm',
})(SignInForm));
